"use client";

import type {VariantProps} from "@gluestack-ui/nativewind-utils";
import {tva} from "@gluestack-ui/nativewind-utils/tva";
import {withStyleContext} from "@gluestack-ui/nativewind-utils/withStyleContext";
import {createSwitch} from "@gluestack-ui/switch";
import React from "react";
import {Switch as RNSwitch} from "react-native";

import {useColors} from "../../../hooks/useColors";

const UISwitch = createSwitch({
    Root: withStyleContext(RNSwitch)
});

const switchStyle = tva({
    base: "data-[focus=true]:outline-0 data-[focus=true]:ring-2 data-[focus=true]:ring-indicator-primary web:cursor-pointer disabled:cursor-not-allowed data-[disabled=true]:opacity-40 data-[invalid=true]:border-error-700 data-[invalid=true]:rounded-xl data-[invalid=true]:border-2",
    variants: {
        size: {
            sm: "scale-75",
            md: "",
            lg: "scale-125"
        }
    }
});

type ISwitchProps = React.ComponentProps<typeof UISwitch> & VariantProps<typeof switchStyle>;
const Switch = React.forwardRef<React.ElementRef<typeof UISwitch>, ISwitchProps>(
    ({className, size = "md", ...props}, ref) => {
        const colors = useColors();
        return (
            <UISwitch
                ref={ref}
                {...props}
                // we probably don't have to fix this on the app
                // because it uses the OS colors
                // @ts-expect-error
                activeThumbColor={colors["--color-blueGray-50"]}
                className={switchStyle({size, class: className})}
                thumbColor={colors["--color-blueGray-50"]}
                trackColor={{
                    false: colors["--color-blueGray-200"],
                    true: colors["--color-primary-500"]
                }}
            />
        );
    }
);

Switch.displayName = "Switch";
export {Switch};
